import React from "react";
import { mapPromotedItemToSignpostCard } from "../../../utils/mappers";
import SectionSignPostCardCarousel from "../../sections/SectionSignPostCardCarousel/SectionSignPostCardCarousel";

export interface SectionSuccessStoryCarouselProps {
	data: Queries.SectionDataFragment;
}

export const SectionSuccessStoryCarousel: React.FC<
	SectionSuccessStoryCarouselProps
> = ({ data }) => {
	const title = data.field_front_end_title;
	const intro = data.field_section_short_description?.value;
	const items = data.promotedLinks.map((item) => ({
		...mapPromotedItemToSignpostCard(item),
		isSuccessStory: true,
	}));
	return (
		<SectionSignPostCardCarousel
			title={title}
			htmlIntro={intro}
			items={items.map((item) => ({ ...item, title: `${item.title}` }))}
			theme={"primary"}
			testimonial={true}
		/>
	);
};

export default SectionSuccessStoryCarousel;
